import {
  COMMERCIAL,
  ENGINEERING_NETWORKS,
  FURNISHING_SUPERVISOR,
  HEAD_EN,
  HEAD_OVP,
  IZS,
  MKD,
  OBSERVER,
  PARTNER,
  PLANNER,
  PRIME_CONTRACTOR,
  HOUSING_CONTRACTOR,
  USK_PRE_ACCEPTANCE,
  SUPERVISOR,
} from 'consts';

import { useAppSelector } from 'hooks';

export const useProfile = () => {
  const profile = useAppSelector(state => state.profile.user);
  const loading = useAppSelector(state => state.profile.loading);

  const { role, accountingType } = profile;

  const isPrimeContractor = role === PRIME_CONTRACTOR;
  const isHousingContractor = role === HOUSING_CONTRACTOR;
  const isUskPreAcceptance = role === USK_PRE_ACCEPTANCE;
  const isHeadOvp = role === HEAD_OVP;
  const isHeadEn = role === HEAD_EN;
  const isPlanner = role === PLANNER;
  const isCommercial = role === COMMERCIAL;
  const isEngineeringNetworks = role === ENGINEERING_NETWORKS;
  const isPartner = role === PARTNER;
  const isObserver = role === OBSERVER;
  const isFurnishingSupervisor = role === FURNISHING_SUPERVISOR;
  const isSupervisor = role === SUPERVISOR;

  const isMKDPrime = Array.isArray(accountingType) ? accountingType.includes(MKD) : false;
  const isIZSPrime = Array.isArray(accountingType) ? accountingType.includes(IZS) : false;

  return {
    profile,
    loading,

    /** Менеджер ОВП */
    isCommercial,
    /** Инженер ОВП */
    isEngineeringNetworks,
    /** Куратор мебели */
    isFurnishingSupervisor,
    /** Руководитель ИС */
    isHeadEn,
    /** Руководитель ОВП */
    isHeadOvp,
    /** Наблюдатель */
    isObserver,
    /** Партнер */
    isPartner,
    /** Планировщик */
    isPlanner,
    /** Генеральный подрядчик */
    isPrimeContractor,
    /** Жилищный подрядчик */
    isHousingContractor,
    /** Предприемка УСК */
    isUskPreAcceptance,
    /** Руководитель */
    isSupervisor,

    /** ИЖС */
    isIZSPrime,
    /** МКД */
    isMKDPrime,
  };
};
